export enum InvoicesActionTypes {
  GET_LIST_INVOICES_SUCCESS = "INVOICES_GET_LIST_SUCCESS",
  GET_LIST_INVOICES_ERROR = "INVOICES_GET_LIST_ERROR",
  GET_LIST_INVOICES = "INVOICES_GET_LIST",
  GET_INVOICE = "GET_INVOICE",
  GET_INVOICE_SUCCESS = "GET_INVOICE_SUCCESS",
  GET_INVOICE_ERROR = "GET_INVOICE_ERROR",
  UPDATE_STATUS_INVOICE = "UPDATE_STATUS_INVOICE",
  UPDATE_STATUS_INVOICE_SUCCESS = "UPDATE_STATUS_INVOICE_SUCCESS",
  UPDATE_STATUS_INVOICE_ERROR = "UPDATE_STATUS_INVOICE_ERROR",
  UPDATE_INVOICE = "UPDATE_INVOICE",
  UPDATE_INVOICE_SUCCESS = "UPDATE_INVOICE_SUCCESS",
  UPDATE_INVOICE_ERROR = "UPDATE_INVOICE_ERROR",
}
